import { Component, Input } from '@angular/core';
import { ElementDateTimeModel, ElementModel, Form, FormElement, TranslationManager, ViewState } from 'src/common';
import { ElementMode, ElementOrderDirection, ElementViewModel } from '../elements.model';

@Component({
  selector: 'element-datetime',
  templateUrl: './element-datetime.component.html'
})
export class ElementDateTimeComponent {

  @Input() mode: ElementMode = ElementMode.Definition;
  elementMode = ElementMode;
  @Input() state: ViewState;
  @Input() showOrderUp: boolean;
  @Input() showOrderDown: boolean;
  viewState = ViewState;
  form: Form = new Form();
  formValue: Form = new Form();
  translationManager = TranslationManager;
  private _element: ElementViewModel;
  elementOrderDirection = ElementOrderDirection;

  @Input() set element(value: ElementViewModel) {
    this._element = value;
    this._element.isValid = this.isValid.bind(this);
    this._element.isValueValid = this.isValueValid.bind(this);
    this._element.getElement = this.getElement.bind(this);
    this._element.getValue = this.getValue.bind(this);
    this.mapElementToForm();
    this.refreshFormState();
  }

  constructor() {
    this.initForm();
  }

  isValid(): boolean {
    return this.form.isValid();
  }

  isValueValid(): boolean {
    return this.formValue.isValid();
  }

  getValue(): any {
    return this.formValue.elements['value'].value;
  }

  getElement(): ElementModel {
    this.mapFormToElement();
    return this._element.element;
  }

  private initForm() {
    this.form.elements['name'] = new FormElement();
    this.form.elements['isMandatory'] = new FormElement();

    this.formValue.elements['value'] = new FormElement();
  }

  private refreshFormState() {
    this.form.elements['name'].state.mandatory = this.mode == ElementMode.Definition;
    this.formValue.elements['value'].state.mandatory = this.form.elements['isMandatory'].value;
  }

  private mapElementToForm() {
    
    let model: ElementDateTimeModel = this._element.element.data as ElementDateTimeModel;

    this.form.elements['name'].value = model.name;
    this.form.elements['isMandatory'].value = model.isMandatory;

    if (this._element.element.value) {
      let date = new Date(this._element.element.value);
      let year = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString();
      let day = date.getDate().toString();

      month = month.length == 1 ? "0" + month : month;
      day = day.length == 1 ? "0" + day : day;

      this.formValue.elements['value'].value = `${year}-${month}-${day}`;
    }
  }

  private mapFormToElement() {
    let model: ElementDateTimeModel = this._element.element.data as ElementDateTimeModel;

    model.name = this.form.elements['name'].value;
    model.isMandatory = this.form.elements['isMandatory'].value;
  }

  delete() {
    this._element.delete(this._element);
  }
}
